import styled from 'styled-components';

export const StyledTransferModal = styled.div`
  .transfer-modal-content {
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: space-between;
    margin: 1.5rem;
    gap: 1.5rem;
  }

  .transfer-list-holder {
    position: relative;
    border-left: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
    border-right: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  }

  .transfer-asset-title {
    font-family: "NeueMachina";
    font-size: 1.5em;
    line-height: 1.2;
    font-weight: 600;
    color: white;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .transfer-panel {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-width: 20rem;
    height: 40vh;
    max-height: 40vh;
  }

  .transfer-asset-note {
    background: ${({ theme }) => theme.backgroundDark};
    padding: 0.5rem;
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: start;
    gap: 0.5rem;
    font-family: "NeueMachina";
    font-size: 1rem;
    line-height: 1.4rem;
  }

  .transfer-button-holder {
    margin-top: 1.5rem;
    width: 20rem;
    min-width: 20rem;
    max-width: 20rem;
  }

  .transfer-asset-image-holder {
    width: 20rem;
    position: relative;
    min-width: 20rem;
    max-width: 20rem;

    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
  
  .transfer-asset-image-holder-bg {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: -1;
  }

  .transfer-button-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    div {
      padding-left: 8px;
      padding-right: 8px;
    }
  }

  .selector-corner {
    width: ${({ theme }) => theme.cornerSize};
    height: ${({ theme }) => theme.cornerSize};
    border: solid ${({ theme }) => theme.frameWidth} white;
    position: absolute;
    animation: corner-scale 0.3s cubic-bezier(0.5, 0.35, 0.15, 1) 0.1s 1 normal forwards;
  }

  .selector-corner-tl {
    border-right: none;
    border-bottom: none;
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    left: 0;
  }

  .selector-corner-tr {
    border-left: none;
    border-bottom: none;
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    right: 0;
  }

  .selector-corner-br {
    border-left: none;
    border-top: none;
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    right: 0;
  }

  .selector-corner-bl {
    border-right: none;
    border-top: none;
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    left: 0;
  }
`;
